import React, { Component } from 'react';
import DatePicker from 'react-mobile-datepicker';
import { render } from 'react-dom';
import {useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { Card, CardHeader, CardBody, Row, Col, Input } from "reactstrap";

import RankingChart from './RankingChart.js';

import "assets/css/chart.css";


let axios = require('axios');
let URL_API = "https://xs458763.xsrv.jp/api/";
function isValidDate(d) {
  return d instanceof Date && !isNaN(d);
}

function RankingCharts(){

  let session = JSON.parse(window.sessionStorage.getItem('sessions'));
  if(!session)
    window.location = '/'; 
    
  const [flag, setFlag]             = useState(0);

  const [dataItems, setDataItems] = useState([]);

  const [s_ranking, s_setRanking] = useState(JSON.parse(window.sessionStorage.getItem("s_ranking")));

  const history = useHistory();

  let player = JSON.parse(window.sessionStorage.getItem('player')); 
    
  if(!player)
    history.push('../parent/userMg');

  const toPage = (e, pname) => {
    history.push('../parent/'+pname);
  }

  const renderItemData = (item, idx) => {
      return (<RankingChart item = {item} player={player}/>);
  }

  const onShowChart = (f) => {
    setFlag(f);
  }

  useEffect(() => {
    // console.log(typeof today);
    if(!session){
        window.location = '/';
    }

  }, []);
  return (
    <>
      <div className="content px-0 pb-0">
        <Row className="px-0 mx-0">
          <Col md="12" className="px-0">
            <Card className="mb-0">
              <CardBody className="seldate p-1 d-flex" id='seldate' style={{color:'white'}}>
                <div className="d-flex col-12 px-2">
                  <div className="col-2 col-lg-1 d-flex align-items-center px-0">
                    <i className="fas fa-chevron-left" style={{fontSize:'20px'}} onClick={(event) => toPage(event, 'son')}></i>
                  </div>
                  <div className="col-8 col-lg-10 text-center px-0 d-flex align-items-center justify-content-center head_title">
                    
                  </div>
                  <div className="col-2 col-lg-1 px-0">
                  </div>
                </div>
              </CardBody>
              <CardBody className=" diary_list px-2 pb-3">
              {
                s_ranking.map((item, idx) => 
                  <div key={idx} style={{fontWeight:'bold'}}>
                    {
                      renderItemData(item, idx)
                    }
                  </div>
                )
              }         
              </CardBody> 
            </Card>
          </Col>
        </Row>
      </div>
    </>
    )
}

export default RankingCharts;